import { motion } from "framer-motion";
import { User, Video, Apple, MessageCircle, Calendar, Users, Check } from "lucide-react";

const iconMap = {
  user: User,
  video: Video,
  apple: Apple,
  message: MessageCircle,
  calendar: Calendar,
  users: Users,
  check: Check,
};

export default function Included({ data }) {
  return (
    <section data-testid="included-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <p className="overline mb-4" data-testid="included-overline">{data.overline}</p>
          <h2
            data-testid="included-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-onyx"
          >
            {data.title}
          </h2>
          <p className="mt-4 text-onyx/70 text-lg">{data.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {(data.items || []).map((item, i) => {
            const Icon = iconMap[item.icon] || Check;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`included-item-${i}`}
                className="bg-white p-8 lg:p-10 hover:bg-alabaster transition-colors group"
              >
                <div className="w-12 h-12 border border-onyx flex items-center justify-center mb-6 group-hover:bg-onyx group-hover:border-onyx transition-colors">
                  <Icon size={20} className="text-onyx group-hover:text-gold transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl text-onyx mb-3">{item.title}</h3>
                <p className="text-onyx/70 leading-relaxed">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
